import React from "react";
import { Text } from "@mantine/core";

const Home = () => {
  return (
    <Text weight="bold" transform="capitalize">
      Welcome to password manager
    </Text>
  );
};

export default Home;
